// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VfLy","content":"styles_content__2IpTL","row":"styles_row__72A__","footer":"styles_footer__Cw9rw","phraseLength":"styles_phraseLength__1skjD"};